
import React from 'react'
import { motion } from 'motion/react'
import { useNavigate, useLocation } from '@tanstack/react-router'
import { Button } from '@/components/ui/button'
import { Icon } from '@/components/ui/icon'

interface HeaderActionsProps {
  className?: string
}

export const HeaderActions: React.FC<HeaderActionsProps> = ({ className }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  const handleNewCanvas = async () => {
    try {
      // Check if we're in a project page and extract the project UUID
      const projectMatch = pathname.match(/^\/workspace\/project\/([^\/]+)/)
      const projectId = projectMatch ? projectMatch[1] : null

      // Navigate to /canvas/new with projectId as query param if in project page
      if (projectId) {
        navigate({ to: '/canvas/new', search: { projectId } })
      } else {
        navigate({ to: '/canvas/new' })
      }
    } catch (error) {
      console.error('Failed to create canvas:', error)
    }
  }

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <motion.div whileTap={{ scale: 0.97 }} transition={{ duration: 0.1 }}>
        <Button variant="secondary" size="lg" onClick={handleNewCanvas}>
          <Icon name="plus" className="mr-2" />
          New Session
        </Button>
      </motion.div>
    </div>
  )
}
